"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCardGroup = IconCardGroup;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const HelperText_1 = require("../components/HelperText");
const Label_1 = require("../components/Label");
const PresentationContext_1 = require("../components/PresentationContext");
const Css_1 = require("../Css");
const IconCard_1 = require("./IconCard");
const utils_1 = require("../utils");
const ErrorMessage_1 = require("./ErrorMessage");
function IconCardGroup(props) {
    var _a;
    const { fieldProps } = (0, PresentationContext_1.usePresentationContext)();
    const { options, label, labelStyle = (_a = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.labelStyle) !== null && _a !== void 0 ? _a : "above", values, errorMsg, helperText, disabled: isDisabled = false, onChange, } = props;
    const [selected, setSelected] = (0, react_1.useState)(values);
    const exclusiveOptions = (0, react_1.useMemo)(() => options.filter((o) => o.exclusive), [options]);
    const toggleValue = (0, react_1.useCallback)((value) => {
        if (isDisabled)
            return;
        const option = options.find((o) => o.value === value);
        if (!option)
            return;
        let newSelected = [];
        if (selected.includes(value)) {
            newSelected = selected.filter((v) => v !== value);
        }
        else {
            if (option.exclusive) {
                newSelected = [value];
            }
            else {
                newSelected = [...selected, value];
                // Filter out any exclusive options as a non-exclusive option was selected.
                newSelected = newSelected.filter((v) => !exclusiveOptions.some((o) => o.value === v));
            }
        }
        setSelected(newSelected);
        onChange(newSelected);
    }, [exclusiveOptions, isDisabled, onChange, options, selected]);
    const tid = (0, utils_1.useTestIds)(props);
    const { labelProps, fieldProps: fieldPropsAria } = (0, react_aria_1.useField)(props);
    const groupProps = (0, react_aria_1.mergeProps)(tid, {
        role: "group",
        "aria-disabled": isDisabled || undefined,
        ...fieldPropsAria,
    });
    return ((0, jsx_runtime_1.jsxs)("div", { ...groupProps, children: [labelStyle !== "hidden" && ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.if(labelStyle === "left").w50.$, children: (0, jsx_runtime_1.jsx)(Label_1.Label, { label: label, ...labelProps, ...tid.label }) })), (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.df.gap2.add({ flexWrap: "wrap" }).$, children: options.map((option) => {
                    const { icon, label, disabled } = option;
                    const isSelected = selected.includes(option.value);
                    return ((0, jsx_runtime_1.jsx)(IconCard_1.IconCard, { icon: icon, label: label, selected: isSelected, disabled: disabled, onChange: () => toggleValue(option.value), ...tid[option.label] }, option.label));
                }) }), errorMsg && (0, jsx_runtime_1.jsx)(ErrorMessage_1.ErrorMessage, { errorMsg: errorMsg, ...tid.errorMsg }), helperText && (0, jsx_runtime_1.jsx)(HelperText_1.HelperText, { helperText: helperText, ...tid.helperText })] }));
}
